import { useMemo } from 'react'

import { useGetExperiment } from '../../../../experiments/hooks'
import { EXPERIMENT_NAME_PDP_PRODUCT_RECOMMENDATION } from '../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../experiments/model/EXPERIMENT_VARIATION'
import { type RecommendationServiceType } from '../../../../recommendation'

type ProductRecommendationWidgetBuyTogetherRequestParams = {
  currentVariantUpid: string
  intersected: boolean
  sellerId: string
  serviceId: RecommendationServiceType
}

type ProductRecommendationWidgetBuyTogetherRequestParamsResult =
  | {
      pid: string
      prodrec?: boolean
      sellerid: string
      serviceId: RecommendationServiceType
    }
  | undefined

export const useProductRecommendationWidgetBuyTogetherRequestParams = ({
  currentVariantUpid,
  intersected,
  sellerId,
  serviceId,
}: ProductRecommendationWidgetBuyTogetherRequestParams): ProductRecommendationWidgetBuyTogetherRequestParamsResult => {
  const prodrecBuyTogetherExperiment = useGetExperiment(
    EXPERIMENT_NAME_PDP_PRODUCT_RECOMMENDATION,
  )
  const isProdrecEnabled =
    prodrecBuyTogetherExperiment.isEnabled &&
    prodrecBuyTogetherExperiment.variant === EXPERIMENT_VARIATION.V1

  return useMemo(
    () =>
      intersected
        ? {
            pid: currentVariantUpid,
            ...(isProdrecEnabled && { prodrec: true }),
            sellerid: sellerId,
            serviceId,
          }
        : undefined,
    [currentVariantUpid, intersected, isProdrecEnabled, sellerId, serviceId],
  )
}
